import "./HowItWorks.module.css";
import Header from "@/reusable_sections/Header";
import TheTransactionRoadmap from "./sections/TheTransactionRoadmap";
import CommonQueries from "./sections/CommonQueries";
import Footer from "@/reusable_sections/Footer";
export default function HowItWorksPage() {
  return <div>
      <Header />
      <TheTransactionRoadmap />
      <CommonQueries />
      <Footer />
    </div>;
}